export default "__VITE_ASSET__CPR3G0o4__"